import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'loyaltic-footer-comingsoon',
  templateUrl: './footer-comingsoon.component.html',
  styleUrls: ['./footer-comingsoon.component.scss']
})
export class FooterComingsoonComponent implements OnInit {

  getTranslateDefaultLang: string;
  allowedCulturesForBranding = ['da-DK', 'nb-NO'];


  constructor(private translate: TranslateService) { }

  ngOnInit() {
    this.getTranslateDefaultLang = this.translate.defaultLang;
  }

  isAegBrandingCulture(): boolean {
    return this.allowedCulturesForBranding.includes(this.getTranslateDefaultLang);
  }

}
